import { useEffect, useRef, useState } from "react";
import { loadTossPayments, ANONYMOUS } from "@tosspayments/tosspayments-sdk";
import { useParams } from "react-router-dom";
import useCheckOut from "../../hooks/pay/useCheckOut";
import Modal from "../../components/common/Modal";
import styled from "styled-components";


function CheckOut() {
  const clientKey = process.env.REACT_APP_TOSS_CLIENT_KEY;
  const { id } = useParams();
  const {isOpenModal, modal, user, order, amount, ready} = useCheckOut(id);
  const [widgets, setWidgets] = useState(null);

  useEffect(() => {
    if(ready){
      async function fetchPaymentWidgets() {
        const tossPayments = await loadTossPayments(clientKey);
        const widgets = tossPayments.widgets({ customerKey: ANONYMOUS });
        setWidgets(widgets);
      }
      fetchPaymentWidgets();
    }
   
  }, [ready]);

  useEffect(() => {
    async function renderPaymentWidgets() {
      if (widgets == null) {
        return;
      }
      /**
       * 위젯의 결제금액을 결제하려는 금액으로 초기화하세요.
       * renderPaymentMethods, renderAgreement, requestPayment 보다 반드시 선행되어야 합니다.
       * @docs https://docs.tosspayments.com/sdk/v2/js#widgetssetamount
       */
      await widgets.setAmount(amount);

      await Promise.all([
        /**
         * 결제창을 렌더링합니다.
         * @docs https://docs.tosspayments.com/sdk/v2/js#widgetsrenderpaymentmethods
         */
        widgets.renderPaymentMethods({
          selector: "#payment-method",
          // 렌더링하고 싶은 결제 UI의 variantKey
          // 결제 수단 및 스타일이 다른 멀티 UI를 직접 만들고 싶다면 계약이 필요해요.
          // @docs https://docs.tosspayments.com/guides/v2/payment-widget/admin#새로운-결제-ui-추가하기
          variantKey: "DEFAULT",
        }),
        /**
         * 약관을 렌더링합니다.
         * @docs https://docs.tosspayments.com/reference/widget-sdk#renderagreement선택자-옵션
         */
        widgets.renderAgreement({
          selector: "#agreement",
          variantKey: "AGREEMENT",
        }),
      ]);
    }

    renderPaymentWidgets();
  }, [widgets]);


  return (
    <div className="wrapper w-100">
      <Modal isOpen={isOpenModal} title={modal.title} content={modal.content} onClose={modal.onConfirmClickHandler}/>
      <div className="max-w-540 w-100">
        <div id="payment-method" className="w-100" />
        <div id="agreement" className="w-100" />
        {widgets ? <div className="btn-wrapper w-100">
          <Button
            className="btn primary w-100"
            onClick={async () => {
              try {
                /**
                 * 결제 요청
                 * 결제를 요청하기 전에 orderId, amount를 서버에 저장하세요.
                 * 결제 과정에서 악의적으로 결제 금액이 바뀌는 것을 확인하는 용도입니다.
                 * @docs https://docs.tosspayments.com/sdk/v2/js#widgetsrequestpayment
                 */
                await widgets?.requestPayment({
                  orderId: id,
                  orderName: "북 스타트업",
                  customerName: user.name,
                  customerEmail: user.email,
                  successUrl: window.location.origin + "/process" + window.location.search,
                  failUrl: window.location.origin + "/fail" + window.location.search
                });
              } catch (error) {
                // TODO: 에러 처리
              }
            }}
          >
            결제하기
          </Button>
        </div> : null}
      </div>
    </div>
  );
}


const Button = styled.button`
    background: #007912;
    border-radius: 12px;
    border: none;
    padding:12px;
    width: 300px;
    color: #FFF;
    font-size: 20px;
    font-weight: 700;
    margin-left: 30px;
    margin-right: 30px;
    cursor: pointer;
`


export default CheckOut;